export const BlogsByCategory = () => {
  return `
        query Categories($status: PublicationStatus, $filters: CategoryFiltersInput, $locale: I18NLocaleCode) {
  categories(status: $status, filters: $filters, locale: $locale) {
    name
    slug
    locale
    blogs {
      author {
        name
      }
      category {
        name
        slug
      }
      title
      slug
      short_description
      priority
      media {
        name
        url
      }
    }
    documentId
  }
}`;
};
